import "./scss/style.scss";
//import 'bootstrap/dist/js/bootstrap.bundle.js';
import 'bootstrap/js/dist/index';
import 'bootstrap/js/dist/util';
import 'bootstrap/js/dist/dropdown';
import 'bootstrap/js/dist/collapse';
import 'bootstrap/js/dist/tab';
import 'bootstrap/js/dist/scrollspy';
import 'bootstrap/js/dist/modal';
import 'lightslider';
import 'lightgallery/src/js/lightgallery.js';
import 'lightgallery/modules/lg-thumbnail.js';
import flatpickr from "flatpickr";
import "flatpickr/dist/l10n/hr.js";
import "select2";
import "select2/dist/js/i18n/hr.js";
import lozad from 'lozad';
import functions from "./js/functions.js";
import "./js/globals.js";
import "./js/loadGmap.js";
import "./js/list.js";
import "./js/details.js";
import "./js/range.js";
import "./js/arrange.js";
//import "./js/input-popover.js";
import "./js/booking.js";
import "./js/contact.js";
import "./js/bookingAddGuests.js";
//import "./js/pagination.js";

flatpickr.localize(flatpickr.l10ns[functions.getLang()]);
flatpickr.l10ns.default.firstDayOfWeek = 1;

window.observer = lozad('.lozad', {
    loaded: function (el) {
        const $slider = $(el).closest('.lSSlideOuter');
        if  ( $slider.length ) {
            $.map($slider.find('.lozad'), observer.triggerLoad);
        }
    }
});
window.observer.observe();